package com.karyadina.service

actual fun createTimerNotificationService(
    sessionTimerManager: SessionTimerManager
): TimerNotificationService {
    return object : TimerNotificationService {
        override fun startMonitoring() {
            // No-op for web
        }

        override fun stopMonitoring() {
            // No-op for web
        }
    }
}
